<template>
  <div>
    <v-autocomplete
      auto-select-first
      v-bind:value="selectedValue"
      v-on:input="updateValue($event)"
      :disabled="isEmpty(routePlanOptions)"
      :items="routePlanOptions"
      :error-messages="errorMessages"
      :loading="loading"
      :label="$tc('route_plan')"
      :placeholder="$t('select_route')"
      prepend-inner-icon="mdi-truck"/>
  </div>
</template>

<script>
import Moment from 'moment-timezone'
import { find, get, isEmpty, map } from 'lodash'

export default {
  name: 'RoutePlanPicker',
  props: {
    value: Object,
    customerId: Number,
    errorMessages: Array
  },
  data () {
    return {
      loading: false,
      routePlans: []
    }
  },
  computed: {
    /**
     * Computed adapter value for v-autocomplete (which doesn't operate off objects). Uses the route plan id.
     * @returns {Number}
     */
    selectedValue () {
      return get(this.value, 'id')
    },
    /**
     * Map the retrieved route plans into an options array for v-autocomplete. We also format the label to include the
     * date.
     * @returns {Array}
     */
    routePlanOptions () {
      return map(this.routePlans, rp => {
        return {
          value: rp.id,
          text: rp.route_number + ' (' + Moment(rp.start).format('LL') + ')'
        }
      })
    }
  },
  methods: {
    isEmpty: isEmpty,
    /**
     * Emit an updated value from the component
     * @param value
     */
    updateValue (value) {
      const selectedRoutePlan = find(this.routePlans, x => x.id === value, 0)
      this.$emit('input', selectedRoutePlan)
    },
    /**
     * Get any route plans with a stop time after a day ago.
     * @returns {Promise<void>}
     */
    async fetchRoutePlans () {
      this.routePlans = []
      try {
        this.loading = true
        const response = await this.$orm('RoutePlan').findAll({
          fields: 'id,route_number,start',
          customer_id: this.customerId,
          'per-page': 0,
          stop_after: '-1 day'
        })
        this.routePlans = response.getItems()
        if (isEmpty(this.routePlans)) {
          // No route plans available in the response, emit an event that the parent component can act upon.
          this.$emit('no-route-plans')
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loading = false
      }
    }
  },
  mounted () {
    this.fetchRoutePlans()
  },
  watch: {
    // Whenever the customer property changes, re-initialize the component.
    customer () {
      this.fetchRoutePlans()
    }
  }
}
</script>

<style scoped>

</style>
